import {
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  Table,
  TableHead,
} from "@mui/material";
import AppleIcon from "@mui/icons-material/Apple";
import { fDateTime } from "src/utils/formatTime";
import Iconify from "../iconify";

export default function PurchasesTable(props) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>ID</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Product ID</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Username</TableCell>
            <TableCell>Transaction ID</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Localized Price</TableCell>
            <TableCell>Transaction Currency</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.purchases?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                {row.store === 0 ? (
                  <AppleIcon />
                ) : (
                  <Iconify icon={"eva:google-outline"} />
                )}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.storePurchaseId}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.price / 100} {"$"}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.productId.toString()}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.email ? row.email.toString() : ""}
              </TableCell>
              <TableCell component="th" scope="row">
                <a href={`/dashboard/profile?user_id=${row.userId}`}>
                  {row.username}
                </a>
              </TableCell>
              <TableCell component="th" scope="row">
                {row.transactionId ? row.transactionId.toString().length > 40
                    ? `${row.transactionId.toString().slice(0, 40)}...`
                    : row.transactionId.toString()
                  : ""}
              </TableCell>
              <TableCell component="th" scope="row">
                {fDateTime(row.purchaseDate)}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.localizedPrice ?? ""}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.transactionCurrency ?? ""}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
